import React from 'react';
import { useListingManagementView } from '../../hooks/useListingManagementView';
import MyListings from '../items/ListingManagement/MyListings';
import AgencyListings from '../items/ListingManagement/AgencyListings';

interface ListingManagementProps {
  userDetails: any;
  onLogout: () => void;
}

const ListingManagement: React.FC<ListingManagementProps> = ({ userDetails, onLogout }) => {
  const { currentView } = useListingManagementView({ userDetails, onLogout });

  if (!userDetails) return null;

  const agencyId = userDetails?.agency?.agencyId;

  return (
    <>
      {currentView === 'my' && <MyListings userId={userDetails.id} />}
      {currentView === 'agency' && agencyId && <AgencyListings agencyId={agencyId} />}
      {currentView === 'agency' && !agencyId && (
        <p style={{ padding: 32, color: '#6c757d' }}>No agency associated with your account.</p>
      )}
    </>
  );
};

export default ListingManagement;
